import { useEffect, useState } from 'react';
import Brand from '../components/Brand';
import { engageAPI } from '../lib/api';
import { t } from '../lib/i18n';
import { panelCls } from '../components/ui';

// The public shareable leaderboard (§3.5) — no auth; 404-config-gated.
export default function PublicLeaderboardPage() {
  const [data, setData] = useState(undefined);

  useEffect(() => {
    engageAPI.publicLeaderboard()
      .then(({ data }) => setData(data))
      .catch(() => setData(null));
  }, []);

  return (
    <div className="min-h-screen px-4 py-12">
      <div className="mx-auto max-w-lg">
        <div className="mb-8 text-center">
          <Brand size="lg" className="justify-center" />
          <h1 className="mt-3 text-lg font-semibold">{t('Leaderboard')}</h1>
        </div>
        {data === undefined ? (
          <p className="text-center text-sm text-mms-muted">{t('Loading…')}</p>
        ) : data === null ? (
          <p className="text-center text-sm text-mms-muted">{t('The leaderboard is not public right now.')}</p>
        ) : (
          <div className={`${panelCls} p-5`}>
            <div className="mb-3 text-xs uppercase tracking-wide text-mms-faint">
              {t(data.metric)} · {data.period}
            </div>
            <ol className="space-y-2 text-sm">
              {data.rows.map((r, i) => (
                <li key={i} className="flex justify-between">
                  <span>{i + 1}. {r.name}</span>
                  <span className="mms-num text-mms-muted">{r.value}</span>
                </li>
              ))}
            </ol>
          </div>
        )}
      </div>
    </div>
  );
}
